import './PageHeader.scss';

/**
 * The one page-title block used by every module screen.
 *
 * Standard structure:
 *   1. Group / Module label — sub-module pages ONLY (e.g. "CONTRACT SETTINGS")
 *   2. Page title           — always the sidebar item that is selected
 *   3. Description          — one short line saying what the page is for
 *
 * Rules this component exists to enforce:
 *   - the parent menu name never appears as a second large heading; it is the
 *     small label above the title, and only on sub-module pages;
 *   - main module pages (Contracts, Documents, My Tasks…) pass no `label`;
 *   - typography, colour and spacing are defined once, here.
 *
 * `actions` renders right-aligned on the title row (page-level buttons).
 * `children` renders under the description, inside the header block — for
 * KPI strips and stat chips that belong to the header rather than the body.
 */
function PageHeader({
  label,
  labelIcon,
  title,
  description,
  actions,
  above,
  children,
  className = '',
}) {
  return (
    <header className={`page-head ${className}`.trim()}>
      <div className="page-head__row">
        <div className="page-head__text">
          {/* `above` occupies the same slot as the group label, so a main module
              page with contextual info (e.g. the dashboard's date + greeting)
              keeps the eyebrow line in the standard position. Pages pass one or
              the other, never both. */}
          {above && <span className="page-head__above">{above}</span>}
          {label && (
            <span className="page-head__label">
              {labelIcon && <span className="page-head__label-icon">{labelIcon}</span>}
              {label}
            </span>
          )}
          <h1 className="page-head__title">{title}</h1>
          {description && <p className="page-head__desc">{description}</p>}
        </div>
        {actions && <div className="page-head__actions">{actions}</div>}
      </div>
      {children}
    </header>
  );
}

export default PageHeader;
